<template>
	<div>
		<el-card class="searchItemFlex">
			<el-date-picker
				v-model="queryLogParams.yearStr"
				value-format="yyyy"
				type="year"
				:clearable="false"
				placeholder="年份"
				style="width: 140px"
				size="mini"></el-date-picker>
			<el-select
				v-model="queryLogParams.month"
				placeholder="月份"
				style="width: 140px"
				size="mini"
				clearable
				filterable
				@clear="queryLogParams.month = null">
				<el-option
					v-for="item in 12"
					:key="item"
					:label="item.toString() + '月'"
					:value="item.toString()"></el-option>
			</el-select>
			<el-input
				v-show="canSeeAll"
				v-model="queryLogParams.userName"
				size="mini"
				style="width: 160px"
				clearable
				placeholder="用户名称"></el-input>
			<el-button type="primary" size="mini" plain @click="queryLogList"
				><i class="el-icon-search"></i>&nbsp;查询</el-button
			>
			<el-button type="warning" size="mini" plain @click="resetQuery"
				><i class="el-icon-refresh-left"></i>&nbsp;重置</el-button
			>
			</el-card>
			<el-card>
			<el-table
				:data="logList"
				ref="LoginLogTable"
				height="610"
				border
				style="width: 100%"
				v-loading="loginLogLoading"
				@sort-change="SortChange"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(255, 255, 255, 0.8)"
				size="mini">
				<el-table-column prop="loginId" label="日志编号" width="110">
				</el-table-column>
				<el-table-column
					prop="xmname"
					label="登录用户"
					width="110"
					:sortable="'custom'">
				</el-table-column>
				<el-table-column
					prop="loginTime"
					label="登入时间"
					width="220"
					:sortable="'custom'">
					<template slot-scope="scope">
						<el-tag
							size="mini"
							type="primary"
							v-if="scope.row.loginTime != null"
							>{{
								scope.row.loginTime | dateformatAll("YYYY-MM-DD HH:mm:ss")
							}}</el-tag
						>
						<el-tag size="mini" type="danger" v-else>无记录</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="logoutTime" label="登出(刷新)时间" width="220">
					<template slot-scope="scope">
						<el-tag
							size="mini"
							type="warning"
							v-if="scope.row.logoutTime != null"
							>{{
								scope.row.logoutTime | dateformatAll("YYYY-MM-DD HH:mm:ss")
							}}</el-tag
						>
						<el-tag size="mini" type="danger" v-else>无记录</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="登录时长" width="130">
					<template slot-scope="scope">
						<el-tag
							size="mini"
							v-if="scope.row.loginTime != null && scope.row.logoutTime != null"
							type="success"
							>{{
								getMinutes(scope.row.loginTime, scope.row.logoutTime)
							}}</el-tag
						>
						<el-tag size="mini" type="danger" v-else>无法计算</el-tag>
					</template>
				</el-table-column>
				<el-table-column
					prop="machine"
					label="登录平台"
					width="180"
					show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag size="mini" type="info">{{ scope.row.machine }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="ip" label="登录IP地址" width="190">
					<template slot-scope="scope">
						<el-tag size="mini" type="success">{{ scope.row.ip }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column> </el-table-column>
			</el-table>
			<!--分页部分-->
			<el-pagination
				background
				@size-change="loginLogPagesizeChange"
				@current-change="loginLogPagenumChange"
				:current-page="queryLogParams.pageNum"
				:page-sizes="[1, 50, 100, 200, 500]"
				:page-size="queryLogParams.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="loginLogTotal"
				style="margin-top: 10px">
			</el-pagination>
		</el-card>
	</div>
</template>

<script>
import dayjs from "dayjs"
//引入日期时间过滤器
export default {
	name: "loginLog",
	data() {
		return {
			userList: [], //用户信息列表
			logList: [], //日志列表
			queryLogParams: {
				yearStr: new Date().getFullYear().toString(),
				month: null,
				userName: "",
				order: 0,
				pageNum: 1,
				pageSize: 50,
			}, //查询参数
			loginLogTotal: 0, //登录总数
			canSeeAll: false, //是否具有查看所有人的权限
			loginLogLoading: false, //加载动画
		}
	},
	mounted() {
		//判断权限
		var rightListStr = window.sessionStorage.getItem("rightList")
		var rightList = JSON.parse(rightListStr)
		if (rightList.indexOf("login_log_all") >= 0) {
			this.canSeeAll = true
		} else {
			this.canSeeAll = false
		}
		this.getLoginLogList()
	},
	methods: {
		//获取登录日志
		async getLoginLogList() {
			if (this.queryLogParams.yearStr == null) {
				return this.$message.warning("必须指定日志年份！")
			}

			this.loginLogLoading = true
			const { data: res } = await this.$http.post(
				"/login/loginLog",
				this.queryLogParams
			).catch(err => err)
			if (res) {
				this.logList = res.logList
				this.loginLogTotal = res.total
			}
			this.loginLogLoading = false
		},
		//排序变化
		SortChange(column) {
			if (column.prop == "loginTime") {
				if (column.order == "ascending" || column.order == null) {
					this.queryLogParams.order = 1
				} else {
					this.queryLogParams.order = 0
				}
			} else if (column.prop == "xmname") {
				if (column.order == "ascending" || column.order == null) {
					this.queryLogParams.order = 3
				} else {
					this.queryLogParams.order = 2
				}
			} else {
				this.queryLogParams.order = 0
			}
			this.getLoginLogList()
		},
		//页面尺寸改变
		loginLogPagesizeChange(newSize) {
			this.queryLogParams.pageSize = newSize
			this.queryLogParams.pageNum = 1
			this.getLoginLogList()
		},
		//切换页
		loginLogPagenumChange(newNum) {
			this.queryLogParams.pageNum = newNum
			this.getLoginLogList()
		},
		//查询
		queryLogList() {
			this.queryLogParams.pageNum = 1
			this.getLoginLogList()
		},
		//重置查询
		resetQuery() {
			this.queryLogParams = {
				yearStr: new Date().getFullYear().toString(),
				month: null,
				userName: "",
				order: 0,
				pageNum: 1,
				pageSize: 50,
			}
			this.$refs.LoginLogTable.columns.forEach(item => {
				item.order = ""
			})
			this.getLoginLogList()
		},

		//获取登录时长
		getMinutes(loginTime, logoutTime) {
			var min = dayjs(logoutTime).diff(loginTime, "minutes")
			if (min > 0) {
				return min + "分钟"
			} else {
				var second = dayjs(logoutTime).diff(loginTime, "seconds")
				return second + "秒钟"
			}
		},
	},
}
</script>

<style></style>
